import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Admin.css';
import {
  FaBullhorn, FaImages, FaUsers, FaEnvelopeOpenText,
  FaBloggerB, FaQuoteRight, FaDatabase, FaSignOutAlt, FaBars, FaTimes
} from 'react-icons/fa';

export const Slidar = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    window.dispatchEvent(new Event('storage'));
    navigate('/login');
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      {/* Mobile Header */}

      <button className="menu-icon" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? "" : <FaBars />}
      </button>



      {/* Sidebar */}
      <div className="">
        <div className={`admin-sidebar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <button onClick={toggleMobileMenu}>
            <FaTimes />
          </button>

          <h2 className="sidebar-title" style={{color:'white'}}>Admin Panel</h2>

          <div className="admin-box-links">
             <Link to="/Adminslider" className="admin-box" onClick={toggleMobileMenu}>
              <FaEnvelopeOpenText /> Add Slider
            </Link>
             <Link to="/Adminblog" className="admin-box" onClick={toggleMobileMenu}>
              <FaBloggerB /> Admin Products
            </Link>
            <Link to="/AdminProductApplications" className="admin-box" onClick={toggleMobileMenu}>
              <FaBloggerB />Buy Applications
            </Link>
             <Link to="/Adminsellform" className="admin-box" onClick={toggleMobileMenu}>
              <FaBloggerB /> Sell Products
            </Link>
             <Link to="/AdminsellApplications" className="admin-box" onClick={toggleMobileMenu}>
              <FaBloggerB />Sell Applications
            </Link>
            <Link to="/AdminTest" className="admin-box" onClick={toggleMobileMenu}>
              <FaQuoteRight /> Admin Team
            </Link>
            <Link to="/logo" className="admin-box" onClick={toggleMobileMenu}>
              <FaDatabase /> Admin Logo
            </Link>
             <Link to="/GalleryEdit" className="admin-box" onClick={toggleMobileMenu}>
              <FaImages /> Edit Gallery
            </Link>
            <Link to="/jobpost" className="admin-box" onClick={toggleMobileMenu}>
              <FaBullhorn /> Post Job
            </Link>
           
            <Link to="/adminview" className="admin-box" onClick={toggleMobileMenu}>
              <FaUsers /> Job Application
            </Link>
           
           
             
            
            
            
            {/* <Link to="/Aboutdat" className="admin-box" onClick={toggleMobileMenu}>
              <FaBullhorn /> About
            </Link> */}
            <div onClick={handleLogout} className="admin-box logout-box" style={{ cursor: 'pointer' }}>
              <FaSignOutAlt /> Logout
            </div>
          </div>
        </div>

      </div>
    </>
  );
};
